/**
 * A series' MEANING, as the token it is drawn in — the owner's colour rule for charts (16 September
 * 2026): sleep blue, energy (and mood) ember, everything else neutral ink. Moved here from
 * `pages/client-detail/ui/SurveyChartsStrip.tsx` on 24 September 2026, when the survey task card
 * became its second reader; the task card still draws by it.
 *
 * `--chart-series-record` (lime) is deliberately absent: it belongs to an exercise result, and a
 * survey charts none.
 */

import type { SurveySeriesHue } from '../model/surveyHistory';

export const HUE_INK: Readonly<Record<SurveySeriesHue, string>> = {
  sleep: 'var(--chart-series-sleep)',
  energy: 'var(--chart-series-mood)',
  neutral: 'var(--chart-series-neutral)',
};

/**
 * The chart STRIP's one ink — on the client's Ankiety tab and in the review inbox (owner, 4 November
 * 2026: „ciepły niebieski"). Every survey series in the strip takes it, whatever it measures; the
 * meaning-keyed table above stays the rule everywhere else. Set here rather than by redefining the
 * `--chart-series-*` variables, which Trendy and the other chart screens read.
 */
export const STRIP_INK = 'var(--warm-blue)';
